<template lang="pug">
shListData(title="Bonos de Compra" resolver="giftVouchers" keyData="_id" component="shGiftVoucher")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'GiftVouchers',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/giftVoucher/GiftVouchers.vue